import React from 'react';
import ReactDOM from 'react-dom/client';
import Index from '.';
import { i18nInit } from "./i18n";
import './index.css';
document.documentElement.style.fontSize = 100 / 375 + "vw";
const rootContainer = document.getElementById("root");
i18nInit().then(() => {
  ReactDOM.createRoot(rootContainer).render(
    <React.StrictMode>
      <Index />
    </React.StrictMode>
  )
})
